import { defineComponent as _defineComponent } from 'vue'
interface Props {
  data?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HtmlContentBlock',
  props: {
    data: { default: undefined }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})